import React from 'react';
import { motion } from 'framer-motion';
import ContactForm from '../components/ContactForm';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const Contact = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="relative h-[60vh] w-full overflow-hidden" data-testid="contact-hero">
        <motion.div
          initial={{ scale: 1.1 }}
          animate={{ scale: 1 }}
          transition={{ duration: 2, ease: 'easeOut' }}
          className="absolute inset-0"
        >
          <img
            src="https://images.unsplash.com/photo-1666094383847-9fae5f90a3c6?crop=entropy&cs=srgb&fm=jpg&q=85"
            alt="Contact Venara Estate"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-primary/60" />
        </motion.div>

        <div className="relative h-full flex items-center justify-center px-6">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-center"
          >
            <h1 className="font-playfair text-4xl sm:text-5xl lg:text-6xl font-bold text-primary-foreground tracking-tight mb-4">
              Let's Connect
            </h1>
            <p className="text-primary-foreground/90 text-lg max-w-2xl">
              Your journey to exceptional luxury living begins with a conversation.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Contact Form Section */}
      <ContactForm />

      {/* Quick Info Section */}
      <section className="py-20 px-6 md:px-12 lg:px-24 bg-primary text-primary-foreground">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="text-center"
              data-testid="contact-info-location"
            >
              <div className="inline-flex items-center justify-center w-16 h-16 border border-secondary/30 mb-4">
                <MapPin className="text-secondary" size={24} />
              </div>
              <h3 className="font-playfair text-lg font-semibold mb-2">Visit Us</h3>
              <p className="text-primary-foreground/70 text-sm">
                Mumbai, Maharashtra<br />India
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="text-center"
              data-testid="contact-info-phone"
            >
              <div className="inline-flex items-center justify-center w-16 h-16 border border-secondary/30 mb-4">
                <Phone className="text-secondary" size={24} />
              </div>
              <h3 className="font-playfair text-lg font-semibold mb-2">Call Us</h3>
              <p className="text-primary-foreground/70 text-sm">
                <a href="tel:+919876543210" className="hover:text-secondary transition-colors duration-300">
                  +91 98765 43210
                </a>
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="text-center"
              data-testid="contact-info-email"
            >
              <div className="inline-flex items-center justify-center w-16 h-16 border border-secondary/30 mb-4">
                <Mail className="text-secondary" size={24} />
              </div>
              <h3 className="font-playfair text-lg font-semibold mb-2">Email Us</h3>
              <p className="text-primary-foreground/70 text-sm">
                <a href="mailto:info@venaraestate.com" className="hover:text-secondary transition-colors duration-300">
                  info@venaraestate.com
                </a>
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="text-center"
              data-testid="contact-info-hours"
            >
              <div className="inline-flex items-center justify-center w-16 h-16 border border-secondary/30 mb-4">
                <Clock className="text-secondary" size={24} />
              </div>
              <h3 className="font-playfair text-lg font-semibold mb-2">Office Hours</h3>
              <p className="text-primary-foreground/70 text-sm">
                Mon - Sat: 10 AM - 7 PM<br />Sunday: By Appointment
              </p>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
